<script lang="ts" setup>
import { BaseballSubParticipantStatId } from '@collector/sportsapi-client-legacy'
import { usePitcherOptions } from '@desktop/views/Relation/Sports/Baseball/composables'

import CurrentPitcherOrBatterSelect from './CurrentPitcherOrBatterSelect.vue'

// composables
const { options, currentPitcher } = usePitcherOptions()
</script>

<template>
  <CurrentPitcherOrBatterSelect
    label="Pitcher"
    :value="currentPitcher"
    :options
    :statId="BaseballSubParticipantStatId.CurrentPitcher"
  />
</template>
